import React, {useState, useEffect} from 'react';
import Time from '../Time';
import '../css/App.css';
import '../css/bootstrap.min.css';
import bootstrap from 'bootstrap';
const axios = require('axios').default;

class Snooze extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        snoozeTime: ""
    }
    this.handleFormChange = this.handleFormChange.bind(this);
    this.snoozeNotification = this.snoozeNotification.bind(this);
  }

  //Just put the correct time on the snoozer
  componentDidMount(){
   
    let currentTimeDate = Time.getComputerTimeDate();
    this.setState({snoozeTime:currentTimeDate});
  }

  //Gets the changes of your form and send it to the state
  handleFormChange = (e) =>{
      this.setState({[e.target.id]: e.target.value});
  }
  
  //Sends a Request to the database to postpone this notification
  snoozeNotification = (e) => {
    e.preventDefault();
    console.log("Snoozing to: "+this.state.snoozeTime);
    console.log("NotificationId: "+this.props.id);

    const formdata = new FormData();
    formdata.append("notificationId", this.props.id);
    formdata.append("snoozeTime", this.state.snoozeTime);

    const requestOptions = {
    method: 'POST',
    body: formdata,
    redirect: 'follow'
    };

    fetch("https://dashboard.realsexdoll.info/php/notifications/snooze.php", requestOptions)
    .then(response => response.text())
    .then(result => this.props.close())
    .catch(error => console.log('error', error));
  }

  render() {
    return(
      <div>
        <div className='pop-up' onClick={this.props.close}></div>
        <div className="container pop-up-window">
            <div className="row">
                <div className="col-12 container p-4">
                  <h3>Snooze</h3>
                  <form onSubmit={this.snoozeNotification}>
                    <div className="mb-3">
                        <label className="form-label">Choose Date:</label>
                        <input defaultValue={this.state.snoozeTime} onChange={this.handleFormChange} type="datetime-local" className="form-control" id="snoozeTime" required></input>
                    </div>
                    <button type="submit" className="btn btn-primary">Snooze</button>
                  </form>
                </div>
            </div>
        </div>
      </div>
    )
  }
}

export default Snooze;